import { EMetroTravelType } from '../../packages/api-models/common/json_query';
import { setRange, setTerm } from './helpers';
import { TJsonQuery } from './types';

export function setUndergroundTravel(
  jsonQuery: TJsonQuery,
): (travelType: EMetroTravelType, travelTime: number | undefined) => TJsonQuery {
  return (travelType, travelTime) => {
    const modifiedJsonQuery = setTerm('only_foot')(jsonQuery)(travelType);

    return setRange('foot_min')(modifiedJsonQuery)(null, travelTime ?? null);
  };
}
